import gql from 'graphql-tag';
import { SHARED_COMMISSION_FRAGMENT } from '../SharedCommission/fragment';
import {
  USER_INFO_FRAGMENT,
  GET_USER_POSSIBLE_ENTITIES_INFO_FRAGMENT,
  USER_ENSEIGNE_ENTITIES_INFO_FRAGMENT,
  USER_HEADER_INFO_FRAGMENT,
  USER_COORDONNEES_INFO_FRAGMENT,
  USER_RATTACHEMENT_INFO_FRAGMENT,
  USER_REGIME_IDENTIFIANTS_INFO_FRAGMENT,
} from './fragment';
import { PERMISSION_FRAGMENT } from '../role/fragment';

export const GET_ME = gql`
  query GetMe {
    me {
      id
      email
      firstName
      lastName
      avatarUrl
      recordDirectoryToken
      roles
      permissions {
        ...PermissionInfo
      }
    }
  }
  ${PERMISSION_FRAGMENT}
`;

export const GET_ALL_USERS = gql`
  query GetAllUsers($input: GetAllUsersInput) {
    getAllUsers(input: $input) {
      totalCount
      users {
        ...UserInfo
      }
    }
  }
  ${USER_INFO_FRAGMENT}
`;

export const GET_MINIMAL_USERS = gql`
  query MinimalUsers($input: GetAllUsersInput) {
    getAllUsers(input: $input) {
      totalCount
      users {
        id
        firstName
        lastName
      }
    }
  }
`;

export const GET_ALL_FILTERED_USERS = gql`
  query GetAllFilteredUsers($input: GetAllUsersInput) {
    getAllUsers(input: $input) {
      totalCount
      users {
        id
        firstName
        lastName
      }
    }
  }
`;

export const GET_USER_INFOS = gql`
  query GetUserInfos($id: Int!) {
    getUser(id: $id) {
      ...UserHeaderInfo
      ...UserCoordonneesInfo
      ...UserRattachementInfo
      ...UserRegimeIdentifiantsInfo
      function
      totalDefaultCommission
      defaultCommissionDistributions {
        ...SharedCommissionInfo
      }
      mandatary {
        id
        firstName
        lastName
      }
    }
  }
  ${USER_HEADER_INFO_FRAGMENT}
  ${USER_COORDONNEES_INFO_FRAGMENT}
  ${USER_RATTACHEMENT_INFO_FRAGMENT}
  ${USER_REGIME_IDENTIFIANTS_INFO_FRAGMENT}
  ${SHARED_COMMISSION_FRAGMENT}
`;

export const GET_USER_ENSEIGNE_AND_ENTITIES = gql`
  query GetUserEnseigneAndEntities($id: Int!) {
    getUser(id: $id) {
      ...UserEnseigneEntitiesInfo
    }
  }
  ${USER_ENSEIGNE_ENTITIES_INFO_FRAGMENT}
`;

export const GET_USER_POSSIBLE_ENTITIES = gql`
  query GetUserPossibleEntities($id: Int!) {
    getUser(id: $id) {
      ...UserPossibleEntitiesInfo
    }
  }
  ${GET_USER_POSSIBLE_ENTITIES_INFO_FRAGMENT}
`;

export const GET_MANDATARIES = gql`
  query Mandataries($filter: String) {
    mandataries(input: { filter: $filter }) {
      id
      firstName
      lastName
    }
  }
`;

export const GET_MANAGERS = gql`
  query Managers {
    managers {
      id
      firstName
      lastName
    }
  }
`;

export const GET_APAS = gql`
  query Apas($input: UserFilterInput) {
    apas(input: $input) {
      id
      firstName
      lastName
    }
  }
`;

export const GET_COLLABORATORS = gql`
  query Collaborators($input: collaboratorsInput) {
    collaborators(input: $input) {
      id
      firstName
      lastName
      entities {
        echelon {
          name
          priority
        }
      }
    }
  }
`;

export const GET_ALL_USER_IN_ENSEIGNE = gql`
  query GetAllUserInEnseigne($input: GetAllUserInEnseigneInput!) {
    getAllUserInEnseigne(input: $input) {
      id
      firstName
      lastName
    }
  }
`;
